/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordInput
 */
export interface ResetPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordInput
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordInput
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the ResetPasswordInput interface.
 */
export function instanceOfResetPasswordInput(value: object): value is ResetPasswordInput {
    return true;
}

export function ResetPasswordInputFromJSON(json: any): ResetPasswordInput {
    return ResetPasswordInputFromJSONTyped(json, false);
}

export function ResetPasswordInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordInput {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}

export function ResetPasswordInputToJSON(json: any): ResetPasswordInput {
    return ResetPasswordInputToJSONTyped(json, false);
}

export function ResetPasswordInputToJSONTyped(value?: ResetPasswordInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'newPassword': value['newPassword'],
    };
}

